export type SystemRole = "worker" | "site_manager" | "admin";

export const SYSTEM_ROLE_HIERARCHY: Record<SystemRole, number> = {
  worker: 1,
  site_manager: 2,
  admin: 3,
};

export const isSystemRole = (value: unknown): value is SystemRole =>
  value === "worker" || value === "site_manager" || value === "admin";
